/**
 * Plain-language labels for notification kinds.
 *
 * Customer-facing copy must never expose an internal kind (`saved_search_matches`,
 * `supplier_restock`, ...). Anything unmapped falls back to neutral wording rather
 * than leaking the raw value.
 */
export const NOTIFICATION_CATEGORY_LABEL: Record<string, string> = {
  price_drop: 'Price drop',
  sold_out: 'Sold out',
  new_match: 'New match',
  buyer_request_match: 'Buy request match',
  saved_search_matches: 'Saved search match',
  restock: 'Restock',
  supplier_restock: 'Supplier restock',
  supplier_update: 'Supplier update',
  buyer_interest: 'Buyer interest',
  desk_moment: 'Your desk',
  buyer_digest: 'Alert digest',
  info_request: 'Info request',
  inventory_refresh: 'Inventory update request',
  menu_shared: 'Menu shared with you',
  message_reply: 'New reply',
  watched_lot_gone: 'No longer available',
  system: 'Update',
};

export const NEUTRAL_NOTIFICATION_LABEL = 'Update';

export const notificationCategoryLabel = (category: string | null | undefined): string =>
  (category && NOTIFICATION_CATEGORY_LABEL[category]) || NEUTRAL_NOTIFICATION_LABEL;
